export const PageName = {
  home: 'Home',
  groupAccessory: 'Nhóm phụ tùng',
  carCompany: 'Hãng xe',
  billOfLading: 'Tra vận đơn',
  brand: 'Thương hiệu',
  promotion: 'Khuyến mãi',
  diary: 'Nhật ký',
  login: 'Đăng nhập',
  forgotPassword: 'Quên mật khẩu',
  resetPassword: 'Đặt lại mật khẩu mới',
  shoppingCart: 'Giỏ hàng',
  accountInfo: 'Thông tin tài khoản',
  product: 'Chi tiết sản phẩm',
  register: 'Đăng ký',
  policy: 'Chính sách',
  catalog: 'Catalog',
}
